module.exports = __webpack_public_path__ + "img/hearts-icon.3178ded.svg";